import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalFooter, ModalHeader, Toast } from "reactstrap";
import Api from "services/api";

const CancelTranslationModal = ({ isOpen, onClose, onConfirm, transId }) => {
  const methods = useForm();
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = methods;

  useEffect(() => {
    methods.reset({ cancel_reason: "" });
  }, [isOpen, methods]);

  console.log(transId, "transId")

  const declineTranslation = async (data) => {
    const payload = new FormData();
    payload.append("reason", data.cancel_reason);
    console.log("DeclineTranslation called. transId:", transId);
    console.log("Payload cancel_reason:", data.cancel_reason);
    try {
      if (transId) {
        const response = await Api.declineTranslationById(transId, payload);
        console.log("Success:", response);
        // Toast(response?.data?.message);
         toast.success(response?.data?.message, {
            className: "successToast",
          });
        if (onConfirm) onConfirm(data, "cancel");
        onClose();
      } else {
        console.warn("transId is missing or invalid.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
      <form onSubmit={handleSubmit(declineTranslation)}>
        <ModalHeader className="header_modal align-items-center">
          <h5 className="modal-title_u">Decline Translation</h5>
        </ModalHeader>
        <ModalBody className="modal_form_body">
          <div className="step_cards min-height-auto">
            {/* Reason */}
            <div className="row-primary">
              <h2>Reason</h2>
              <Controller
                name="cancel_reason"
                control={control}
                rules={{
                  required: "Please write reason",
                }}
                render={({ field }) => (
                  <>
                    <textarea
                      className="type_inp input-in"
                      {...field}
                      placeholder="Write reason for Cancel ..."
                      required
                    ></textarea>

                    {errors?.cancel_reason?.message && (
                      <ErrorMessage text={errors?.cancel_reason?.message} />
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            className={"tomatoRed"}
            btnText="Decline Invite"
            type="submit"
          />
          <button className="Cancle_button" type="button" onClick={onClose}>
            Close
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CancelTranslationModal;
